import React, { useState, useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import moment from "moment";

const FallEventList = ({...props}) => {

  const srNumberFormatter = (cell, row, rowIndex, formatExtraData) => {
    if (props.currentPage > 1)
      return <>{props.perPage * (props.currentPage - 1) + (rowIndex + 1)}</>;
    else return <>{rowIndex + 1}</>;
  };

  const nameFormatter = (cell, row) => {
    return (
      <>
        <div>
          {" "}
          {`${cell.firstName !== null ? cell.firstName : ""} ${cell.lastName !== null ? cell.lastName : ""
            }`}
        </div>
      </>
    );
  };

  const dateFormatter = (cell, row) => {
    return `${moment(row.eventTimestamp).format("MM/DD/YYYY")}  ${moment(
      row.eventTimestamp
    ).format("hh:mm A")}`;
  };

  const contactsFormatter = (cell, row) => {
    if (row.contactsNotified.call.length > 0) {
    return  row.contactsNotified.call.map((val) => {
        return <div>
          {`${val.firstName} ${val.lastName} [${val.phoneNumber}]`}
        </div>
      })
    } else return "";
  };

  const columns = [
    {
      dataField: "id",
      text: "No.",
      formatter: srNumberFormatter,
    //   headerStyle: () => {
    //     return { width: "65px" };
    //   },
    },
    {
      dataField: "eventTimestamp",
      text: "EVENT DATE/TIME ",
      formatter: dateFormatter,
    },
    {
      dataField: "address",
      text: "LOCATION",
    },
    {
      dataField: "alertContacts",
      text: "ALERTED CONTACTS",
      formatter: contactsFormatter
    },
  ];

  const defaultSorted = [
    {
      dataField: "startDate",
      order: "desc",
    },
  ];

  return (
      <div>
        <BootstrapTable
          keyField="id"
          data={props.fallEventList.sort((t1, t2) => {
            if (t1.eventTimestamp > t2.eventTimestamp) return -1;
            if (t1.eventTimestamp < t2.eventTimestamp) return 1;
            return 0;
          })}
          columns={columns}
          striped
          hover
          condensed
          bordered={false}
          //defaultSorted={defaultSorted}
        />
      </div>
  );
};

export default FallEventList;
